<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
            <li><a href="/#/pit" v-on:click="sendMsg">井下振动监测</a></li>
            <li class="active">精密实验室选址振动监测和振动评价</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px">精密实验室选址振动监测和振动评价</h1>
            <hr>
            <p class="titleP">精密实验室选址振动监测和振动评价的重要性</p>
            <p>精密和超精密仪器设备对使用环境的振动要求比较苛刻，但近年来随着城市交通网的兴建，地铁或城铁不可避免地会穿过各类精密实验室区域，从而加剧了对实验室的污染，使高精密仪器出现信噪比低、数据准确度下降等问题。因此，对于精密实验室选址的振动监测和振动评价显得尤为重要。井下地脉动监测是选址的重要手段，然而井下地脉动监测也面临着防水、抗高压、定向等难题。</p>
            <p class="titleP">精密实验室选址振动监测和振动评价方案</p>
            <p>首先布点选择，需要怎样分布测点；然后安装井下振动传感器，选择所测方向。最后进行监测，数据分析，判断能否使用该场地。</p>
            <p class="titleP">精密实验室选址振动监测和振动评价的设备选择</p>
            <p>传感器：BY-S07D型低频振动传感器
              该传感器低频性能好，传感器有四个档位，1档为加速度档，2,3,4档为速度档，用户可以自行选择一个档位由厂家固定。传感器防护等级达到IPX8，防水抗压性能好。有独特的井下安装方式，能在井下定向。
              数据采集仪选择：D1000型数据采集仪、D3000型数据采集仪。
              精密实验室选址振动监测周期一般为3个月左右，数据采集仪供电是重点。D1000型数据采集仪是通过适配器将交流电转为9—36V直流供电，而D3000型数据采集仪是通过适配器进行15V直流供电。如若测试环境无交流电，可以采用锂电池逆变成交流电，再使用适配器给数据采集仪供电。
            </p>
            <p class="titleP">精密实验室选址振动监测和振动评价的流程图</p>
            <div style="width:80%;margin: 0 auto 50px">
              <img src="../../../assets/center/pit/laboratory/f1.png" alt="" style="width:100%;height:auto;">
            </div>
            <p class="titleP">精密实验室选址振动监测和振动评价案例</p>
            <p>2019年初，我公司在某场地安装BY-S07D型低频振动传感器，进行精密实验室选址振动监测。</p>
            <div style="width:50%;margin: 0 auto 50px">
              <img src="../../../assets/center/pit/laboratory/c1.png" alt="" style="width:100%;height:auto;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/center/pit/laboratory.vue